import * as React from "react"

import {
    Action,
    ActionAnchor,
    ActionType,
} from "@tenforce/toolbox-button-push-react"

import { ButtonSymbols } from "../../../../symbols"
import env from "../../../../env"
import { IButton } from "../index"

interface Props {
    button: IButton
    executeCallAction: (event: React.MouseEvent, button: IButton) => void
    extraClasses?: string
    separatorExtraClasses?: string
}

export const ContextMenuAction = ({
    button,
    executeCallAction,
    extraClasses,
    separatorExtraClasses,
}: Props): JSX.Element => {
    const { buttonData, caption, icon, showCaption, tooltip } = button

    const tooltipText = tooltip.length > 0 ? tooltip : caption

    const iconSymbol = ButtonSymbols.has(icon)
        ? `${ButtonSymbols.get(icon)}`
        : ""

    const content = (
        <>
            {iconSymbol}
            {!!iconSymbol && showCaption && <>&nbsp;</>}
            {showCaption && caption}
        </>
    )

    return (
        <>
            {buttonData.type === "Separator" && (
                <div
                    className={`separator-line is-dotted is-dimmed ${separatorExtraClasses}`}
                ></div>
            )}

            {buttonData.type === "Link" && (
                <ActionAnchor
                    actionType={ActionType.block}
                    extraClasses={extraClasses}
                    href={
                        buttonData.url[0] === "/"
                            ? env.applicationPath + buttonData.url
                            : buttonData.url
                    }
                    target={buttonData.opensNewTab ? "_blank" : ""}
                    data-ft-caption={caption}
                    id={buttonData.actionId}
                    title={tooltipText}
                >
                    {content}
                </ActionAnchor>
            )}

            {buttonData.type === "Call" && (
                <Action
                    actionType={ActionType.block}
                    extraClasses={extraClasses}
                    onClick={(event: React.MouseEvent): void => {
                        executeCallAction(event, button)
                    }}
                    data-ft-caption={caption}
                    id={buttonData.actionId}
                    title={tooltipText}
                >
                    {content}
                </Action>
            )}
        </>
    )
}

ContextMenuAction.defaultProps = {
    extraClasses: "tw-p-2",
    separatorExtraClasses: "tw-py-2",
}

export default ContextMenuAction
